import Phaser from 'phaser';
import { seedIfEmpty } from '../../content/seed';
import { appState } from '../../app/state';

export class BootScene extends Phaser.Scene {
  constructor() { super({ key: 'Boot' }); }

  async create() {
    const { width, height } = this.scale;
    this.cameras.main.setBackgroundColor(0x1b1530);
    this.add.text(width / 2, height / 2, 'WizardSpeak', {
      color: '#f5efff',
      fontSize: '36px',
      fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
      fontStyle: 'bold',
    }).setOrigin(0.5);
    this.add.text(width / 2, height / 2 + 40, 'loading…', {
      color: '#f5efff',
      fontSize: '14px',
      fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
    }).setOrigin(0.5).setAlpha(0.6);

    await seedIfEmpty();
    await appState.boot();

    // Subscribe to global screen changes and route to the right Phaser scene.
    appState.on((s) => {
      switch (s.screen.kind) {
        case 'academy':
          if (!this.scene.isActive('Academy')) {
            this.scene.start('Academy');
          } else {
            this.scene.bringToTop('Academy');
          }
          break;
        case 'zone':
          this.scene.start('Zone', { lessonId: s.screen.lessonId });
          break;
        case 'combat':
          // CombatScene is launched from ZoneScene, not directly routed.
          break;
        case 'profile-picker':
        case 'parent':
        case 'ingest':
          // Preact overlay; we still want the world rendered behind it.
          break;
      }
    });
  }
}
